import { render, staticRenderFns } from "./bookSuccess.vue?vue&type=template&id=4ddb1dd9&scoped=true"
import script from "./bookSuccess.vue?vue&type=script&lang=js"
export * from "./bookSuccess.vue?vue&type=script&lang=js"
import style0 from "./bookSuccess.vue?vue&type=style&index=0&id=4ddb1dd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb1dd9",
  null
  
)

export default component.exports